module.exports = __webpack_public_path__ + "img/package_in_vault_713.3486af69.jpg";